import { supabase } from '../supabaseClient';

const recentLogs = new Map();
const LOG_DEDUPE_MS = 10 * 60 * 1000;
export const SLOW_PRO_FETCH_MS = 4000;

export function logProIntelligenceGap(daId, reason, metadata = {}) {
  if (!daId || typeof supabase.rpc !== 'function') return;

  const key = `${daId}:${reason}`;
  const now = Date.now();
  const last = recentLogs.get(key) || 0;
  if (now - last < LOG_DEDUPE_MS) return;
  recentLogs.set(key, now);

  supabase.rpc('log_da_pro_intelligence_gap', {
    p_da_id: daId,
    p_reason: reason,
    p_metadata: metadata,
  }).then(({ error }) => {
    // supabase-js resolves { error } rather than rejecting — a .catch alone
    // would never see PostgREST failures.
    if (error) console.warn('[SiteScope] Pro gap signal failed:', error.message);
  });
}

export function logSlowProFetch(daId, startedAt, metadata = {}) {
  const elapsedMs = Date.now() - startedAt;
  if (!Number.isFinite(elapsedMs) || elapsedMs < SLOW_PRO_FETCH_MS) return elapsedMs;

  logProIntelligenceGap(daId, 'slow_pro_fetch', {
    ...metadata,
    elapsed_ms: elapsedMs,
    slow_threshold_ms: SLOW_PRO_FETCH_MS,
  });
  return elapsedMs;
}
